import './style.scss'
import './google-events'
import '../node_modules/@splidejs/splide/dist/css/splide.min.css'

import Splide from '@splidejs/splide';
import MicroModal from 'micromodal';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';

MicroModal.init();

jQuery(function() {
  jQuery('.tab-title').each(function() {
    let section_id = jQuery(this).find("a").attr("href");

    jQuery(this).find("a").removeAttr("href");

    jQuery(this).on('click', function() {
      jQuery(this).siblings().removeClass("active-tab");
      jQuery(this).addClass("active-tab");
      jQuery('.tab-content').hide();

      jQuery(section_id).show();
    });
  });

  //Open first tab on page load
  let first_tab = jQuery('.tab-title')[0];

  if (first_tab) {
    first_tab.click();
  }

  jQuery(document).on('change', '#tax_exempt_checkbox', function() {
    $('body').trigger('update_checkout');
  })

});

const splideDefaultOptions = {
  perPage: 4,
  perMove: 1,
  gap: 30,
  breakpoints: {
    576: {
      perPage: 1
    },
    992: {
      perPage: 2
    },
    1200: {
      perPage: 3
    }
  }
}

if (document.querySelector('.splide-cross_sells')) {
  new Splide( '.splide-cross_sells', splideDefaultOptions).mount();
}

if (document.querySelector('.splide-upsells')) {
  new Splide( '.splide-upsells', splideDefaultOptions).mount();
}

if (document.querySelector('.splide-related-categories')) {
  new Splide( '.splide-related-categories', splideDefaultOptions).mount();
}

if (document.querySelector('.splide_product-thumbnails')) {
  new Splide( '.splide_product-thumbnails', {
    perPage: 4,
    perMove: 1,
    gap: 10,
    breakpoints: {
      1200: {
        perPage: 3
      }
    }
  }).mount();
}

const productSliders = document.querySelectorAll('.splide-products-slider');

productSliders.forEach(element => {
  new Splide( element, splideDefaultOptions).mount();
})

jQuery(function() {

  const thumbnails = jQuery('.splide_product-thumbnails li');

  thumbnails.on('click', function() {
    let index = jQuery(this).index();

    jQuery('.splide_product-thumbnails li.flex-active').removeClass('flex-active');
    jQuery(this).addClass('flex-active');
    jQuery('.woocommerce-product-gallery').flexslider(index);
  })
});

function addToCartConversion(form, quantity) {
  let item_name = form.dataset.productName;
  let variant = form.dataset.productVariant;
  let sku = form.dataset.productSku;
  let index = parseInt(form.dataset.index);

  let sale_price = parseFloat(form.dataset.productSalePrice);
  let regular_price = parseFloat(form.dataset.productRegularPrice);
  let cost = 0;
  let discount = 0;

  if (sale_price) {
    cost = sale_price;
    discount = regular_price - sale_price;
  } else {
    cost = regular_price;
  }

  let item_id = sku ? sku : variant;

  dataLayer.push({ ecommerce: null });

  dataLayer.push({
    event: 'add_to_cart',
    ecommerce: {
      value: cost,
      currency: 'USD',
      items: [
        {
          'item_id': item_id,
          'item_name': item_name,
          'discount': discount,
          'index': index,
          'price': regular_price,
          'quantity': quantity
        }
      ]
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('.product-variant .add-to-cart form');

  document.addEventListener('click', function(e) {
    const target = e.target;

    if (target.classList.contains('trigger-request-quote-modal')) {
      e.preventDefault();

      //Check if this is a link in a tooltip and destroy the tooltip
      let tooltip = target.closest('.tippy-box');
      if (tooltip) {
        let button = target.closest('form').querySelector('.add-to-cart-btn');

        button._tippy.destroy();
      }

      //Open the request a quote modal
      showRequestQuoteModal(forms);
    }
  });


  if (forms.length > 0) {
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        let product_id = form.querySelector('input[name="add-to-cart"]').value;
        let quantity = form.querySelector('input[name="quantity"]').value;
        let variation_id = form.querySelector('input[name="variation_id"]') ? form.querySelector('input[name="variation_id"]').value : '';

        let data = {
          action: 'divichild_woocommerce_ajax_add_to_cart',
          product_id: product_id,
          quantity: quantity,
          variation_id: variation_id
        }

        const params = new URLSearchParams(data);

        let addToCartBtn = form.querySelector('.add-to-cart-btn')
        let loadingSpinner = form.querySelector('.loading-spinner');

        addToCartBtn.classList.add('loading');
        addToCartBtn.disabled = true;
        loadingSpinner.style.display = 'inline-block';

        fetch(wc_add_to_cart_params.ajax_url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
          },
          body: params
        }).then(response => {
          return response.json();
        }).then(data => {
          addToCartBtn.classList.remove('loading');
          addToCartBtn.disabled = false;
          loadingSpinner.style.display = 'none';

          if (data.success){
            addToCartConversion(form, quantity);
            let cart_total = data.cart_total;

            let cart = document.querySelector('.et-cart-info span');
            cart.textContent = cart_total;
            addToCartBtn.innerHTML = 'Added!';

            setTimeout(function () {
              addToCartBtn.innerHTML = 'Add';
            }, 1000);
          } else {
            let notices = [];

            for (const notice of data.notices) {
              notices.push(notice.notice);
            }

            let content = `<p>${notices.join('<br>')}</p>`;

            const tooltip = tippy(addToCartBtn, {
              content: content,
              allowHTML: true,
              placement: 'bottom',
              interactive: true,
              theme: 'light-border',
              trigger: 'manual',
            });

            tooltip.show();
          }
        })
      })
    })
  }

  const searchToggle = document.querySelector('#search-toggle');
  const searchForm = document.querySelector('.aws-container');

  if (searchToggle) {
    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      window.getComputedStyle(searchForm).display === 'none' ? searchForm.style.display = 'flex' : searchForm.style.display = 'none';
    })
  }


})

function showRequestQuoteModal(forms) {

  let requestQuoteFormList = document.querySelector('.products_list .gfield_list_groups');

  while(requestQuoteFormList && requestQuoteFormList.childElementCount > 1) {
    requestQuoteFormList.removeChild(requestQuoteFormList.lastElementChild);
  }

  Array.from(forms).find(element => {
    let quantity = element.querySelector('#quantity').value;

    if (quantity) {
      let product = element.dataset.productName;
      let variant = element.dataset.productVariant;

      let formList = document.querySelector('.products_list .gfield_list_groups');
      let lastElementChild = formList.lastElementChild;
      let nodes = lastElementChild.childNodes

      nodes[0].querySelector('input').value = product;
      nodes[1].querySelector('input').value = variant;
      nodes[2].querySelector('input').value = quantity;

      let lastRow = document.querySelector('.products_list .gfield_list_groups .gfield_list_group:last-child');
      let addItem = lastRow.querySelector('.add_list_item');

      addItem.click();
    }
  })

  MicroModal.show('request-quote-modal');
}

document.addEventListener('DOMContentLoaded', function() {
  const subscribeBtn = document.querySelector('.subscribe-newsletter');
  if (subscribeBtn) {
    subscribeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      MicroModal.show('newsletter-modal');
    });
  }
});

jQuery(function() {
  let data = {
    action: 'divichild_load_notifications',
    uri: location.href,
  }

  jQuery.ajax({
    type: 'POST',
    url: divichild_ajax.ajax_url,
    dataType: 'json',
    data: data,
    success: function(response) {
      if (response) {
        jQuery('#notifications-banner').html(response);
      }
    }
  })
})

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

document.addEventListener('click', (e) => {
  const target = e.target.closest('.notifications__close');

  if (target) {
    e.preventDefault();
    let banner = target.closest('.notifications__banner');
    let notificationId = banner.dataset.notificationId;

    setCookie(`popco_notification_${notificationId}`, 'dismissed', 30);

    banner.remove();
  }

})

document.addEventListener('DOMContentLoaded', function() {
  const elements = document.querySelectorAll('.custom-extrusion__content a');
  for (const element of elements) {
    element.setAttribute('target', '_blank');
  }
});

